import React from "react";
import { Spinner } from "@shopify/polaris";

/**
 * Centered loader inside a Page (first visit / data fetch).
 */
export default function PageLoader({ label = "Loading", size = "large" }) {
  return (
    <div className="age-page-loader" role="status" aria-live="polite">
      <Spinner accessibilityLabel={label} size={size} />
    </div>
  );
}
